import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Activity, Heart, Shield, Zap, Hand, User, Sparkles, Flame } from "lucide-react";
const services = [{
  id: 1,
  title: "Back Pain Treatment",
  description: "Expert assessment and treatment for acute and chronic back pain using evidence-based techniques.",
  icon: Activity
}, {
  id: 2,
  title: "Osteoarthritis Management",
  description: "Comprehensive care plans designed to reduce pain and improve mobility for osteoarthritis patients.",
  icon: Heart
}, {
  id: 3,
  title: "Shoulder Pain Rehabilitation",
  description: "Specialised rehabilitation programs to restore shoulder function and eliminate pain.",
  icon: Shield
}, {
  id: 4,
  title: "Sports Injury Treatment",
  description: "Fast-track recovery for athletes with personalised treatment plans and performance optimization.",
  icon: Zap
}, {
  id: 5,
  title: "Sports Massage",
  description: "Therapeutic massage techniques to enhance athletic performance, prevent injuries, and accelerate recovery.",
  icon: Hand
}, {
  id: 6,
  title: "Neck Pain Treatment",
  description: "Targeted therapy for neck pain and stiffness, restoring comfortable movement.",
  icon: User
}, {
  id: 7,
  title: "Acupuncture Therapy",
  description: "Dry-needling techniques combined with modern physiotherapy to relieve pain and restore movement",
  icon: Sparkles
}, {
  id: 8,
  title: "Chronic Pain Management",
  description: "Long-term pain management strategies using evidence-based approaches to help you regain control and improve quality of life.",
  icon: Flame
}];
export default function ComprehensivePhysiotherapyServices() {
  return <section className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h1 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4 tracking-wide animate-fade-in-up">
            Physiotherapy and Sports Massage in Doncaster
          </h1>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed animate-fade-in-up-delay-100">
            At Align Physiotherapy, we provide expert, evidence-based care tailored to your individual needs. Our commitment is to help you move better, feel better, and get back to doing what you love.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-12">
          {services.map((service, i) => {
          const IconComponent = service.icon;
          return <Card key={service.id} data-index={i} className="border border-border shadow-soft hover:-translate-y-1 hover:shadow-medium transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] bg-background">
                <CardHeader>
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center">
                      <IconComponent className="w-6 h-6 text-accent" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <CardTitle className="text-xl font-display font-semibold text-foreground mb-2">
                        {service.title}
                      </CardTitle>
                      <CardDescription className="text-sm text-muted-foreground leading-relaxed">
                        {service.description}
                      </CardDescription>
                    </div>
                  </div>
                </CardHeader>
              </Card>;
        })}
        </div>

        <div className="text-center">
          <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 transition-all duration-150 font-semibold px-8 py-6 text-base rounded-lg shadow-soft">
              Book an Appointment
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}